import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-739d2519"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalQuestions, (q, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "tab",
        style: _normalizeStyle(_ctx.backgroundColor(index))
      }, null, 4))
    }), 128))
  ]))
}